import { render } from "./AddCard.vue?vue&type=template&id=0eb65d5d&scoped=true&ts=true"
import script from "./AddCard.vue?vue&type=script&lang=ts"
export * from "./AddCard.vue?vue&type=script&lang=ts"

import "./AddCard.vue?vue&type=style&index=0&id=0eb65d5d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb65d5d"]])

export default __exports__